<template>
  <div>
        <a-tabs v-model="currentTab" @change="handleTabChange">
          <a-tab-pane key="1" tab="问诊评价">
          </a-tab-pane>
          <a-tab-pane key="2" tab="护理评价">   </a-tab-pane>
        </a-tabs>

        <div v-if="currentTab =='1'">
          <consult-evaluation/>
        </div>
        <div v-if="currentTab =='2'">
          <nursing-evaluation/>
        </div>
  </div>
</template>
<script>
  import { STable, XDown } from '@/components'
  import moment from 'moment'
  import consultEvaluation from './consultEvaluation.vue'
  import nursingEvaluation from './nursingEvaluation.vue'
  export default {
    components: {
      STable,
      consultEvaluation,
      nursingEvaluation,
      XDown
    },
    data () {
      return {
        currentTab: '1',
      }
    },
    methods: {
      moment,
      handleTabChange(key) {
          console.log('切换tabs页',key)
          this.currentTab = key
        },
    }
  }
</script>
<style lang="less">
  .table-operator {
    margin-bottom: 18px;
  }
  button {
    margin-right: 8px;
  }
  .ant-tabs-bar{
      margin:0;
      padding: 16px 16px 0px;
      background: #fff;
    }
</style>
